export default "__VITE_ASSET__051a9acd__"